<template>
    
</template>

<script>

    export default {
        name: "BackgroundImageMixin",
        data () {
            return {
                classToValueMapping : {
                    "centered" : "centered-bg",
                    "stretched" : "stretched-bg",
                    "repeated" : "repeated-bg",
                    "auto-repeated" : "auto-repeated-bg"
                },
            }
        },
        computed: {
            nodeWithBgImage () {
                return this.myNode;
            }
        },
        methods: {
            getBgImage () {
                let bgImageSrc = this.getStyleProperty("background-image",{defaultValue:""},this.nodeWithBgImage).replace("url","").replace("(","").replace(")","").replace(/('|")/g, '');

                if (!bgImageSrc && this.myData?.imageMediaData?.link) {
                    bgImageSrc = this.myData.imageMediaData.link;
                }

                if (bgImageSrc.indexOf("repeating-linear") > -1) {
                    bgImageSrc = "";
                }

                return bgImageSrc;
            },
            removeBgImage () {

                if (!this.nodeWithBgImage) {
                    return;
                }

                if (this.nodeWithBgImage.classList.contains(this.defaultImageClass ? this.defaultImageClass : "learnworlds-bg-default")) {
                    this.nodeWithBgImage.style.backgroundImage =  "none";
                } else {
                    this.nodeWithBgImage.style.backgroundImage =  null;
                }
            },
            toggleBgImageDisplay (flag) {
                if (flag) {
                    this.nodeWithBgImage.style.display =  null;
                    this.insertBgImage();
                } else {
                   this.removeBgImage();
                }
            },
            setBgImage (imageData) {
                this.changeMyData({imageMediaData: imageData});
                this.insertBgImage();
                this.setChangesAreSaved(false);
            },
            getBgImagePosition () {
                let bgImageStyle = "auto-repeated";

                if (this.nodeWithBgImage) {

                    for (let value in this.classToValueMapping) {
                        if (!this.classToValueMapping.hasOwnProperty(value)) {
                            continue;
                        }

                        let className = this.classToValueMapping[value];

                        if (this.nodeWithBgImage.classList.contains(className)) {
                            bgImageStyle = value;
                        }
                    }
                }

                return bgImageStyle;
            },
            setBgImagePosition (data) {
                let allClasses = Object.keys(this.classToValueMapping).map(key => {
                    if (this.classToValueMapping[key]) {
                        return this.classToValueMapping[key];
                    }
                })

                let newData = {
                    newClass : this.classToValueMapping[data.value],
                    classesToRemove : allClasses
                }

                this.applyClass(newData,this.nodeWithBgImage);
            },
            insertBgImage () {

                // if (this.getBgImage() && (!this.myData.imageData || (this.myData.imageData && !this.myData.imageData.link))) {
                //     this.changeMyData({imageMediaData: {link: this.getBgImage()}});
                // }

                let imageData = this.myData.imageMediaData;

                let callback = function () {
                    window.eventBus.$emit("nodeImageLoaded");
                }

                if (!this.nodeWithBgImage) {
                    return;
                }

                //get rid of old ones
                if (callback) {
                    this.nodeWithBgImage.removeEventListener("load",callback);
                    this.nodeWithBgImage.addEventListener("load",callback);
                }

                if (imageData && imageData.link) {
                    this.nodeWithBgImage.style.backgroundImage =  "url(" + imageData.link + ")";
                } else {
                    this.nodeWithBgImage.style.backgroundImage =  null;
                }


            }
        },
    }
</script>

